type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
  strokeColor?: string;
};

/**
 * Muted-speaker glyph — speaker cone with an "X" mark to the right where
 * the sound waves would normally be. Used when a player's volume is at 0
 * or the user has explicitly muted; pairs with `SpeakerIcon` (unmuted).
 *
 * Matches the standard mute-control affordance YouTube paints in its
 * desktop watch player.
 */
const SpeakerMutedIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    fillColor = 'currentColor',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path d="M8.5 2.5 4.75 5.5H2.25v5h2.5L8.5 13.5v-11Z" fill={fillColor} />
      <path
        d="M11 5.5 14.5 10M14.5 5.5 11 10"
        stroke={strokeColor}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SpeakerMutedIcon;
